import { Component, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../core/navigation.service';
import { LeftPanelService } from '../../../../layout/home/services/left-panel.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../core/security/user.service';
import { AbstractFormWidgetComponent } from '../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { DirectMovesActionService } from '../services/direct-moves-action.service';
import { DetailedEntityDataService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { LookupInputComponent } from '../../../../shared/components/lookup-input/lookup-input.component';
import { DatePickerConfigService } from '../../../../shared/components/datepicker/datepicker-config.service';


@Component({
  selector: 'lfwms-direct-moves-accordian',
  templateUrl: './direct-moves-accordian.component.html',
  styleUrls: ['./direct-moves-accordian.component.css']
})
export class DirectMovesAccordianComponent extends AbstractFormWidgetComponent {
  @ViewChildren(LookupInputComponent) public primeFocusLookup: QueryList<LookupInputComponent>;
  @ViewChild('primeFocus') private primeFocus;

  public setPrimeFocus(property: any) {
    if (this.metadataMap[property].displayType === 'E') {
      this.primeFocus.nativeElement.focus();
    } else if (this.metadataMap[property].displayType === 'EL' || this.metadataMap[property].displayType === 'L') {
      this.primeFocusLookup.toArray().forEach(lookupRef => {
        if (lookupRef.dataModel.cName === property) {
          lookupRef.setFocusOnCell();
          return;
        }
      });
    }
  }

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    public actionService: DirectMovesActionService,
    public dataService: DetailedEntityDataService,
    public dateConfigService: DatePickerConfigService) {
    super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
  }

  // need to clear the sku field onchange of storerKey field
  public onValueChangeInTypeaheadTextBox(event) {
    this.valueChanged(event.propertyName, event);
    if (event.propertyName === 'storerKey' && event.prevVal !== event.newVal && this.dataService.primaryDataMap['sku'].cVal) {
      this.dataService.primaryDataMap['sku'].cVal = '';
    }
  }
}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/direct-moves/direct-moves-accordian/direct-moves-accordian.component.ts